import { blocks } from '@yola/ws-sdk';
import getParentBlockByElement from 'src/js/modules/blocks/helpers/get-parent-block-by-element';
import resizeHandlePositions from '../../../common/constants/resize-handle-positions';
import isPositioningImage from './is-positioning-image';
import isBusinessLogo from './is-business-logo';
import getPositioningBoundingArea from '../../../common/helpers/get-positioning-bounding-area';
import { compositeItemConfig } from '../constants/resize-trigger-default-configs';

const LOGO_ALIGNMENT_ATTRIBUTE = 'logo-alignment';

const getVisibleResizeTriggers = (element, handlersConfig) => {
  const fallback = {
    [resizeHandlePositions.BOTTOM_CENTER]: handlersConfig[resizeHandlePositions.BOTTOM_CENTER],
  };

  const positionSet = new Set();

  if (!element) return fallback;

  const blockElement = getParentBlockByElement(element);
  const blockId = blocks.accessors.getBlockIdByElement(blockElement);
  const settings = blocks.accessors.getBlockSettings(blockId);

  let resizing;

  if (!settings || !settings.resizing?.length) {
    resizing = [compositeItemConfig];
  } else {
    resizing = [...settings.resizing, compositeItemConfig];
  }

  const matchedSetting = [...resizing, compositeItemConfig].find((setting) =>
    element.matches(setting.querySelector)
  );
  if (!matchedSetting) return fallback;
  const availableDirections = matchedSetting.directions;

  availableDirections.forEach((direction) => positionSet.add(direction));

  const isLogo = isBusinessLogo(element);
  const isCenteredLogo =
    isLogo && blockElement?.getAttribute(LOGO_ALIGNMENT_ATTRIBUTE) === 'center';

  if (isCenteredLogo) {
    positionSet.add(resizeHandlePositions.CENTER_LEFT);
    positionSet.add(resizeHandlePositions.BOTTOM_LEFT);
  }

  if (
    positionSet.has(resizeHandlePositions.BOTTOM_LEFT) ||
    positionSet.has(resizeHandlePositions.CENTER_LEFT)
  ) {
    const { marginLeftStyleProperty } = element;
    if (marginLeftStyleProperty !== 'auto' && !isPositioningImage(element) && !isCenteredLogo) {
      positionSet.delete(resizeHandlePositions.BOTTOM_LEFT);
      positionSet.delete(resizeHandlePositions.CENTER_LEFT);
    }
  }

  if (
    positionSet.has(resizeHandlePositions.BOTTOM_RIGHT) ||
    positionSet.has(resizeHandlePositions.CENTER_RIGHT)
  ) {
    const { marginRightStyleProperty } = element;
    if (marginRightStyleProperty !== 'auto' && !isPositioningImage(element) && !isLogo) {
      positionSet.delete(resizeHandlePositions.BOTTOM_RIGHT);
      positionSet.delete(resizeHandlePositions.CENTER_RIGHT);
    }
  }

  if (isPositioningImage(element)) {
    const elementBounds = element.getBoundingClientRect();
    const { boundingRect: positioningAreaBounds } = getPositioningBoundingArea(element);
    const isElementOutsidePositioningAreaAlongYAxis =
      Math.round(elementBounds.height) > Math.round(positioningAreaBounds.height);

    if (isElementOutsidePositioningAreaAlongYAxis) {
      positionSet.delete(resizeHandlePositions.TOP_LEFT);
      positionSet.delete(resizeHandlePositions.TOP_CENTER);
      positionSet.delete(resizeHandlePositions.TOP_RIGHT);
    }
  }

  const result = {};

  positionSet.forEach((pos) => {
    result[pos] = handlersConfig[pos];
  });
  return result;
};

export default getVisibleResizeTriggers;
